import isDateWithinRange from '@/utils/withinDateRange';
import { vehicleHirePropsProps } from '@/types/types';

// This measure the distance between two dates/times
// and return the number of days, rounded up.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const treatAsUTC = (date: Date): any => {
    const result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
};

export function daysBetween(startDate: Date, endDate: Date) {
    const millisecondsPerDay = 24 * 60 * 60 * 1000;

    return Math.ceil(
        (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay
    );
}

export function calculateVehiclePrice(
    numRentalDays: number,
    collectionDate: Date | null,
    chosenVehicle: vehicleHirePropsProps | null
): { price: number; usedSeasonalPrice?: boolean; used84DayPrice?: boolean } {
    if (!numRentalDays || numRentalDays < 1)
        return { price: 0, usedSeasonalPrice: false };

    const isSummer = isDateWithinRange(collectionDate); // if isSummer is false, then it's the equivalent of isWinter being true

    const round = (value: number) =>
        Math.round((value + Number.EPSILON) * 100) / 100;

    const {
        pricePerDay,
        pricePer2Days,
        pricePer6Days,
        pricePerWeek,
        pricePer4WeeksSummer,
        pricePer4WeeksWinter,
        pricePer84Days,
    } = chosenVehicle || {};
    let calculatedPrice;
    const summerWinterPrice = isSummer
        ? pricePer4WeeksSummer
        : pricePer4WeeksWinter;

    switch (true) {
        case numRentalDays === 1:
            return { price: pricePerDay as number, usedSeasonalPrice: false };
        case numRentalDays > 1 && numRentalDays < 6:
            return {
                price: round(((pricePer2Days as number) / 2) * numRentalDays),
                usedSeasonalPrice: false,
            };
        case numRentalDays === 6:
            return { price: pricePer6Days as number, usedSeasonalPrice: false };
        case numRentalDays === 7:
            return { price: pricePerWeek as number, usedSeasonalPrice: false };
        case numRentalDays > 7 && numRentalDays <= 27:
            calculatedPrice = round(
                ((pricePerWeek as number) / 7) * numRentalDays
            );
            return calculatedPrice > summerWinterPrice!
                ? {
                      price: summerWinterPrice as number,
                      usedSeasonalPrice: true,
                  }
                : { price: calculatedPrice, usedSeasonalPrice: false };
        case numRentalDays > 27 && numRentalDays <= 83:
            calculatedPrice = round(
                ((summerWinterPrice as number) / 28) * numRentalDays
            );
            return calculatedPrice > pricePer84Days!
                ? {
                      price: round(pricePer84Days as number),
                      usedSeasonalPrice: true,
                  }
                : {
                      price: calculatedPrice,
                      usedSeasonalPrice: false,
                  };
        case numRentalDays > 83:
            return {
                price: ((pricePer84Days as number) / 84) * numRentalDays,
                usedSeasonalPrice: false,
            };
        default:
            return { price: 0, usedSeasonalPrice: false };
    }
}
